"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Typography;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var S = _interopRequireWildcard(require("./styled"));

function Typography(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body2' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'textPrimary' : _ref$color,
      _ref$disableOverflowW = _ref.disableOverflowWrap,
      disableOverflowWrap = _ref$disableOverflowW === void 0 ? false : _ref$disableOverflowW,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["variant", "color", "disableOverflowWrap"]);
  return /*#__PURE__*/_react["default"].createElement(S.Typography, Object.assign({
    variant: variant,
    color: color,
    disableOverflowWrap: disableOverflowWrap
  }, rest));
}